import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { AutocompleteResult } from '../../../models/autocomplete-result';

import { StylesheetService } from '../../../services/documents/stylesheet.service';

@Component({
  selector: 'app-stylesheet-search',
  templateUrl: './stylesheet-search.component.html',
  styleUrls: ['./stylesheet-search.component.scss'],
  providers: [],
})
export class StylesheetSearchComponent implements OnInit, OnChanges {
  /**
   * Stylesheet search term
   * @type {string}
   */
  stylesheetSearchTerm: string;

  /**
   * Indicates if include search result item in output
   */
  @Input() include_item: boolean = false;

  /**
   * Additional params for autocomplete search
   */
  @Input() params: any = {};

  /**
   * Stylesheet id for initial selection
   */
  @Input() stylesheetId: number | undefined;

  /**
   * Indicates if input size should be small based on bootstrap form-control class
   */
  @Input() small_input: boolean = false;

  /**
   * Indicates if search should be allowed
   */
  @Input() editable: boolean = true;

  /**
   * Get placeholder from parent component and overrides the default in HTML
   */
  @Input() placeholder: string;

  /**
   * Output contact id on stylesheet selection
   * @param {EventEmitter<string> = new EventEmitter(} ) stylesheet_id variable name
   */
  @Output() stylesheet_id: EventEmitter<string> = new EventEmitter();

  /**
   * Indicates if stylesheet selection is only to be sent as output and not show in the HTML
   */
  @Input() select_only: boolean = false;

  /**
   * Output selected stylesheet item from the search results
   * @param {EventEmitter<any>    = new EventEmitter(} ) stylesheet variable name
   */
  @Output() stylesheet: EventEmitter<any> = new EventEmitter();

  /**
   * Outputs if stylesheet is to be cleared
   * @param {EventEmitter<any>    = new EventEmitter(} ) clearStylesheet variable name
   */
  @Output() clearStylesheet: EventEmitter<any> = new EventEmitter();

  /**
   * Constructor
   * @param {StylesheetService} private stylesheetService Service to access stylesheets controller for search related actions
   */
  constructor(private stylesheetService: StylesheetService) {}

  // Component lifecycle events

  /**
   * Called on component initialization
   */
  ngOnInit() {}

  /**
   * Called on component variable changes
   * @param {any} changes Angular changes object with variables changed and current value
   */
  ngOnChanges(changes: any) {
    if (changes.stylesheetId && changes.stylesheetId.currentValue && !this.select_only)
      this.stylesheetService.getStylesheetInfo(this.stylesheetId!).then((response_json) => {
        this.stylesheetSearchTerm = response_json.label;
      });
    else if (this.select_only) this.stylesheetSearchTerm = '';
  }

  /**
   * Called to clear selected stylesheet and output to parent component
   */
  clearSelectedStylesheet(): void {
    this.stylesheetId = undefined;
    this.stylesheetSearchTerm = '';
    this.clearStylesheet.emit('clearStylesheet');
  }

  /**
   * Called when stylesheet search result item is selected
   * @param {any} item Search result item as per AutoComplete format of label and value fields
   */
  stylesheetSearchOnSelect(item: any): void {
    if (this.include_item) this.stylesheetId = item.id;
    else this.stylesheetId = item;
    if (this.select_only) {
      let scope = this;
      this.stylesheet.emit(item);
      window.setTimeout(function () {
        scope.stylesheetSearchTerm = '';
      }, 100);
    } else if (this.include_item) {
      this.stylesheet.emit(item);
      this.stylesheet_id.emit(String(item.id));
    } else this.stylesheet_id.emit(String(item));
  }
}
